import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Loading } from 'tdesign-react';
import { fetchPolices, fetchProPolices } from '@/slices/topicSlice';
import { isEmpty } from '@/utils/common';
import SvgIcon from '@/components/SvgIcon';
import KeepPolicy from './KeepPolicy';
import LimitPolicy from './LimitPolicy';
import SchemaPolicy from './SchemaPolicy';
import PersistencePolicy from './PersistencePolicy';
import ClientLimitPolicy from './ClientLimitPolicy';

export const toText = (val, unit) => {
  const txt = isEmpty(val) ? '-' : val;
  return unit ? `${txt} (${unit})` : txt;
};

function ConfigPanel({ commonProps, fetchPolices, fetchProPolices, loading }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetchPolices(commonProps);
    fetchProPolices(commonProps);
  }, [fetchPolices, commonProps, fetchProPolices]);

  return (
    <Loading delay={500} loading={loading}>
      <Root>
        <KeepPolicy commonProps={commonProps} />
        <LimitPolicy commonProps={commonProps} />
        <SchemaPolicy commonProps={commonProps} />

        <Title onClick={() => setVisible((vis) => !vis)}>
          高级配置 <Icon type='chevron-double-up' rotate={visible ? 0 : 180} />
        </Title>
        {visible && (
          <div className='fadeIn'>
            <PersistencePolicy commonProps={commonProps} />
            <ClientLimitPolicy commonProps={commonProps} />
          </div>
        )}
      </Root>
    </Loading>
  );
}

export default connect(
  (state) => ({
    loading: state.topic.policesFetching,
  }),
  {
    fetchPolices,
    fetchProPolices,
  },
)(ConfigPanel);

const Root = styled.div`
  .descriptions {
    margin-top: 16px;
  }
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: var(--td-brand-color-7);
  padding: 20px 0 6px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const Icon = styled(SvgIcon)`
  transition: 0.4s all cubic-bezier(0.645, 0.045, 0.355, 1);
  transform: rotate(${(props) => props.rotate}deg);
  margin-left: 4px;
`;
